import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    platFromId: '',
    platFromArray: '',
    columnTree: []
  },
  mutations: {
    SET_PlAT_FROM_ID(state, platFromId) {
      state.platFromId = platFromId;
    },
    SET_PlAT_FROM_Array(state, platFromArray) {
      state.platFromArray = platFromArray;
    },
    SET_COLUMN_TREE(state, columnTree) {
      state.columnTree = columnTree;
    }
  }
})

export default store;
